import { useContext, useState } from "react";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { SpiderChart } from "../../../d3charts/spider/Spider";
import { PopupImage } from "./PopupImage";

export const HorizonChartConfig = ({ config }) => {
  const refs = useContext(RefContext);
  const [lstore] = useContext(LocalStoreContext);
  const { horizonFiltered } = lstore;
  const [hoveredLabel, setHoveredLabel] = useState();

  return horizonFiltered &&
    horizonFiltered.data &&
    horizonFiltered.data.length > 0 ? (
    <div>
      <SpiderChart
        data={horizonFiltered}
        width={refs.componentSize.current["HorizonSpider"].width}
        height={refs.componentSize.current["HorizonSpider"].height}
        config={config}
        sref={refs.spiderRef}
        setHoveredLabel={setHoveredLabel}
      />
      {hoveredLabel && (
        <PopupImage
          hoveredLabel={hoveredLabel}
          width={refs.componentSize.current["HorizonSpider"].width}
          height={refs.componentSize.current["HorizonSpider"].height}
        />
      )}
    </div>
  ) : null;
};
